import React, {useEffect, useState} from "react";
import {AEInput, Card, CardBody, CardFooter, CardHeader, Pagination} from "../../../../../_metronic/_partials/controls";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {useMetadata} from "../../../../../_emywork/AEPagination";
import {actionTypes} from "../../_redux/slice";
import {fetchEntities} from "../../_redux/actions";
import {AESVG} from "../../../../../_emywork/components/svg";
import {useIntl} from "react-intl";
import {AEButton} from "../../../../../_emywork/components/buttons";
import {useFormik} from "formik";
import KTAppChat from "../../../../../_metronic/_assets/js/components/chat";
import {Content} from "./Content";
import {AEDuration} from "../../../../../_emywork/components/moment";
import moment from "moment";
import ReactExport from "react-data-export";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export function List() {
  const dispatch = useDispatch();
  const {formatMessage} = useIntl();
  const [id, setId] = useState();
  const { authUser } = useSelector( ({auth}) => ({ authUser:auth.user }), shallowEqual );

  const { entities, meta, isLoading } = useSelector(
    state => {
      return state.contacts[actionTypes.List]
    }
    , shallowEqual )
  const metadata = useMetadata(meta);
  const { page, perPage, sortAsc, filters, sortField, select, setPerPage, setFilters, total } = metadata;

  const formik = useFormik({
    initialValues: filters,
    onSubmit: (values)=>{
      const { search } = values;
      setFilters(values)
    }
  });
  //
  const getEntities = () => {
    dispatch(fetchEntities(metadata.toAEMetadata())).then(r=>{
      KTAppChat.init()
    });
  }

  useEffect(() => {
    getEntities()
  }, [dispatch, page, perPage, filters, select, sortField, sortAsc]);


  useEffect(() => {
    formik.handleSubmit()
  }, [formik.values.search]);

  useEffect(() => {
    if(!id){
      if(entities.length>0){
        setId(entities[0].id);
      }
    }
  }, [entities, id]);

  return (
    <>
      {/*<div className={'d-flex flex-row'} id="kt_chat_aside">*/}
      <div className={'row'} id="kt_chat_aside">
        {/*<div className={'flex-row-auto -offcanvas-mobile w-350px w-xl-400px -offcanvas-mobile-on'} id="kt_chat_aside">*/}
        <div className={'col-md-5'} id="kt_chat_aside">
          <Card className={'mb-0'}>
            <CardBody >
              <div className={'d-flex'}>
                <AEInput
                  borderless
                  validation={false}
                  withFeedbackLabel={false}
                  className={"form-control-solid"}
                  field={formik.getFieldProps('search')}
                  form={formik}
                  name={"search"}
                  label={"SEARCH"}
                />


                <ExcelFile
                  element={
                    <AEButton
                      variant={'clean'}
                      icon
                    >
                      <AESVG
                        variant={'primary'}
                        path={"/Files/Download.svg"}

                      />
                    </AEButton>
                  }
                >
                  <ExcelSheet data={entities} name="Contacts">
                    <ExcelColumn label="Name" value="name"/>
                    <ExcelColumn label="Email" value="email"/>
                    <ExcelColumn label="Note" value="note"/>
                    <ExcelColumn label="Phone" value="phone"/>
                  </ExcelSheet>
                </ExcelFile>
              </div>

              {/*<div className="mt-7 scroll scroll-pull">*/}
              <div
                className="mt-7 scroll scroll-pull"
                // style={{maxHeight: 400}}
              >
                {/* user */}
                {
                  entities.map(contact=>(
                    <div key={contact.id} className="d-flex align-items-center justify-content-between mb-3">
                      <div className="d-flex align-items-center">
                        <div className={`symbol symbol-circle symbol-30 mr-3`}>
                          <span className="symbol-label">
                            <AESVG
                              path={"/Communication/Adress-book2.svg"}
                              variant={id === contact.id ? 'primary' : ''}
                            />
                          </span>
                        </div>

                        <div className="d-flex flex-column">
                          <a href="#" className="text-dark-75 text-hover-primary font-weight-bold font-size-lg"
                            onClick={e=>{
                              e.preventDefault();
                              setId(contact.id);
                            }}
                          >
                            {contact.name}
                          </a>
                          {/*<span className="text-muted font-weight-bold font-size-sm">*/}
                          {/*  /!*don't remove condition contact.members && : state issue*!/*/}
                          {/*  { formatMessage({id:'MEMBER.COUNT'}, {count: contact.members && contact.members.length + 1}) }*/}
                          {/*</span>*/}
                        </div>
                      </div>
                      <div className="d-flex flex-column align-items-end">
                        <span className="text-muted font-weight-bold font-size-sm">
                          {
                            contact.last_message &&
                            <AEDuration
                              duration={moment().diff(moment(contact.last_message.created_at), 'seconds')}
                              unit={'seconds'}
                              // argWithSuffix
                            />
                          }
                        </span>
                      </div>
                    </div>
                  ))
                }

                {
                  total > perPage &&
                  <AEButton
                    variant={'link-primary'}
                    block
                    onClick={()=>{
                      setPerPage(perPage+10)
                    }}
                  >
                    {formatMessage({id:'LOAD_MORE'})}
                  </AEButton>
                }

              </div>

              <div className={'text-center pt-2'}>
                {
                  formatMessage(
                    {id:"METADATA.PAGINATION.DISPLAY_OF"},
                    {display: Math.min(perPage, total), total:total}
                  )
                }
              </div>
            </CardBody>

          </Card>
        </div>
        {/*<div className="offcanvas-mobile-overlay" />*/}
        {/*<div className={'flex-row-fluid ml-lg-8'} id={'kt_chat_content'}>*/}
        {/*<div className={'col-lg-7 ml-lg-8'} id={'kt_chat_content'}>*/}
        <div className={'col-md-7'}>
          {
            id &&
            <Content id={id} onUpdate={getEntities}/>
          }

        </div>
      </div>

    </>
  );
}
